// See: https://teacherspayteachers.atlassian.net/browse/DF-1440?focusedCommentId=153445
// See: https://github.com/TeachersPayTeachers/assessments-fe/blob/c1094e76b0c7c432e3ccfc7d51e6be122ce7449d/src/global/hooks/useFocus.ts.

import { useEffect, useState } from "react";

export const useFocus = (): boolean => {
  const [hasFocus, setHasFocus] = useState(
    document.visibilityState === "visible"
  );

  const onVisibilityChange = () => {
    setHasFocus(document.visibilityState === "visible");
  };

  useEffect(() => {
    window.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      window.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);

  return hasFocus;
};
